import * as React from "react";
import Paper from "@mui/material/Paper";
import Button from "../../components/Button";
import Spinner from "../../components/Spinner";
import { Box, Typography } from "@mui/material";
import CustomTextField from "../../components/Textfield";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { useFormik } from "formik";
import DashboardWrapper from "../../components/DashboardWrapper";
import { sendBroadcast } from "../../http/common";
import { showToast } from "../../store/slices/common";

export default function BroadcastNotification() {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const initialValues = {
    title: "",
    text: "",
    url: "",
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    text: Yup.string().required("Text is required"),
    url: Yup.string()
      .required("Url is required")
      .url("Please enter correct url"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      saveHandler(values);
    },
  });

  const handleChange = (e) => {
    formik.setFieldValue(e.target.name, e.target.value);
  };

  const saveHandler = async (values) => {
    try {
      setLoading(true);
      const payload = {
        url: values?.url,
        title: values.title,
        text: values.text,
        platform: "Chrome",
      };
      const res = await sendBroadcast(payload);
      if (res.status === 200) {
        dispatch(showToast({ color: "success", msg: res.data.message?.en }));
      }
    } catch (err) {
      console.log(err);
      dispatch(
        showToast({ color: "error", msg: err?.response?.data?.message?.en })
      );
    } finally {
      setLoading(false);
    }
  };

  const getDisabled = () => {
    return !formik.values.title || !formik.values.text;
  };

  return (
    <DashboardWrapper>
      <Paper
        sx={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
          boxSizing: "border-box",
          boxShadow: "none",
        }}
      >
        {loading && <Spinner />}
        <Box
          display="flex"
          maxWidth="380px"
          flexDirection="column"
          padding={{ xs: "0", md: "0 20px" }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Typography
              className="header"
              color="#687F89"
              width="100%"
              fontWeight="400"
              fontSize="16px"
            >
              Title
            </Typography>
            <Box
              borderRadius="40px"
              display="flex"
              marginTop="15px"
              width="100%"
              flexDirection="column"
              justifyContent="center"
            >
              <CustomTextField
                type="text"
                name="title"
                placeholder="Title"
                value={formik.values.title}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.title && Boolean(formik.errors.title)}
                errorMessage={formik.touched.title && formik.errors.title}
              />
            </Box>
            <Typography
              className="header"
              color="#687F89"
              marginTop="24px"
              width="100%"
              fontWeight="400"
              fontSize="16px"
            >
              Text
            </Typography>
            <Box
              borderRadius="40px"
              display="flex"
              marginTop="15px"
              width="100%"
              flexDirection="column"
              justifyContent="center"
            >
              <CustomTextField
                type="text"
                name="text"
                placeholder="Text"
                value={formik.values.text}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.text && Boolean(formik.errors.text)}
                errorMessage={formik.touched.text && formik.errors.text}
              />
            </Box>
            <Typography
              className="header"
              color="#687F89"
              marginTop="24px"
              width="100%"
              fontWeight="400"
              fontSize="16px"
            >
              Url
            </Typography>
            <Box
              borderRadius="40px"
              display="flex"
              marginTop="15px"
              width="100%"
              flexDirection="column"
              justifyContent="center"
            >
              <CustomTextField
                type="text"
                name="url"
                placeholder="Text"
                value={formik.values.url}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.url && Boolean(formik.errors.url)}
                errorMessage={formik.touched.url && formik.errors.url}
              />
              <Typography marginTop={"10px"}>
                Link/URL should be in the format as
                https://www.budgetbutterfly.ca
              </Typography>
            </Box>
            <Box
              borderRadius="40px"
              display="flex"
              marginTop="2rem"
              width="100%"
              flexDirection="column"
              justifyContent="center"
            >
              <Button
                style={{ marginTop: 0, width: "50%", minWidth: "150px" }}
                className="theme-btn-contained theme-btn theme-auth-btn"
                label="Send"
                variant="contained"
                color="primary"
                typeButton="submit"
                disabled={getDisabled()}
              />
            </Box>
          </form>
        </Box>
      </Paper>
    </DashboardWrapper>
  );
}
